export const backend_url = 'https://premint-karma.df.r.appspot.com/api';
export const napoleon_twitter_id = '1518879060113248256';
